
const PATH = '/symbols';

function stringifyFilters (filters) {

    if (!filters) return null;
    if (filters && Object.keys(filters).length === 0) return null;
    return JSON.stringify(filters);
}


export default {
    async querySymbols({ query}) {

        return axios.get(`${PATH}/query`, {params: {query}});
    },
    async querySymbolsPreview() {

        return axios.get(`${PATH}/query/preview`);
    },
    async filterSymbols(parameters) {

        return axios.post(`${PATH}/filter`, parameters);
    },
    async getSymbolPeers(symbol) {

        return axios.get(`${PATH}/${symbol}/info/peers`);
    },
    async getSymbolPeersDev(symbol) {

        return axios.get(`${PATH}/${symbol}/info/peers/d`);
    },
    async getSymbolInfo(symbol) {

        return axios.get(`${PATH}/${symbol}/info`);
    },
    async getWatchlistSymbols () {

    },
    async getSymbolsByIndex ({index, filters}) {

        let params = {filters: stringifyFilters(filters)};
        return axios.get(`${PATH}/index/${index}`, {
            params,
        });
    }
}
